module.exports = __webpack_public_path__ + "static/member02-b203732d1a53f41548bc1349a833aab0.png";